var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299.528,
    height: 47.984,
    viewBox: "0 0 299.528 47.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kasookoo_Masterlogo",
    "data-name": "Kasookoo Masterlogo",
    transform: "translate(-41.5 -180.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(41.5 180.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M85.648,189.9a21.957,21.957,0,0,0-10.468,2.847l1,2.763a18.81,18.81,0,0,1,9.3-2.6c6.113,0,9.714,3.433,9.714,10.049v1.424a32.332,32.332,0,0,0-9.8-1.424c-7.621,0-12.9,3.852-12.9,10.635v.167c0,6.783,5.862,10.3,11.389,10.3a13.063,13.063,0,0,0,11.305-6.281v5.443h2.764V202.8c0-4.02-1-7.034-3.015-9.3C92.766,191.156,89.584,189.9,85.648,189.9Zm9.547,21.02c0,5.946-5.192,10.133-11.138,10.133-4.522,0-8.542-2.764-8.542-7.537v-.084c0-4.606,3.433-7.621,9.714-7.621a34.374,34.374,0,0,1,10.049,1.507v3.6Z",
    transform: "translate(-46.54 -182.866)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M120.361,204.957c-4.187-1.34-8.207-2.68-8.207-6.364v-.167c0-3.266,2.68-5.695,6.7-5.695A15.537,15.537,0,0,1,127.9,196l1.507-2.6a18.578,18.578,0,0,0-10.468-3.6c-5.695,0-9.714,3.768-9.714,9.044v.167c0,5.862,5.36,7.453,10.133,8.961,4.1,1.256,7.788,2.68,7.788,6.532v.167c0,3.768-3.1,6.2-7.118,6.2a16.034,16.034,0,0,1-10.552-4.271L107.8,219.11a18.788,18.788,0,0,0,12.059,4.773c5.695,0,10.217-3.768,10.217-9.547v-.167C130.159,208.307,125.135,206.381,120.361,204.957Z",
    transform: "translate(-52.278 -182.849)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M153.841,189.6c-8.793,0-15.241,7.956-15.241,17.167v.167c0,9.212,6.364,17,15.074,17,8.793,0,15.241-7.956,15.241-17.167V206.6C169,197.472,162.634,189.6,153.841,189.6ZM165.9,206.935c0,7.7-5.025,14.069-12.059,14.069-6.867,0-12.143-6.281-12.143-14.236V206.6c0-7.7,5.025-14.069,12.059-14.069,6.867,0,12.143,6.281,12.143,14.236Z",
    transform: "translate(-57.286 -182.817)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M193.941,189.6c-8.793,0-15.241,7.956-15.241,17.167v.167c0,9.212,6.365,17,15.074,17,8.793,0,15.241-7.956,15.241-17.167V206.6C209.015,197.472,202.65,189.6,193.941,189.6ZM206,206.935c0,7.7-5.025,14.069-12.059,14.069-6.867,0-12.143-6.281-12.143-14.236V206.6c0-7.7,5.025-14.069,12.059-14.069,6.867,0,12.143,6.281,12.143,14.236Z",
    transform: "translate(-63.805 -182.817)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M266.841,189.6c-8.793,0-15.241,7.956-15.241,17.167v.167c0,9.212,6.364,17,15.074,17,8.793,0,15.241-7.956,15.241-17.167V206.6C281.915,197.472,275.55,189.6,266.841,189.6ZM278.9,206.935c0,7.7-5.025,14.069-12.059,14.069-6.867,0-12.143-6.281-12.143-14.236V206.6c0-7.7,5.025-14.069,12.059-14.069,6.867,0,12.143,6.281,12.143,14.236Z",
    transform: "translate(-75.656 -182.817)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M306.941,189.6c-8.793,0-15.241,7.956-15.241,17.167v.167c0,9.212,6.365,17,15.074,17,8.793,0,15.241-7.956,15.241-17.167V206.6C322.015,197.472,315.651,189.6,306.941,189.6ZM319,206.935c0,7.7-5.025,14.069-12.059,14.069-6.867,0-12.143-6.281-12.143-14.236V206.6c0-7.7,5.025-14.069,12.059-14.069,6.867,0,12.143,6.281,12.143,14.236Z",
    transform: "translate(-82.175 -182.817)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M41.5,221.864h2.847V196.909h0V181.5H41.5Z",
    transform: "translate(-41.5 -181.5)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M68.046,190.5H64.278L51.8,204.9l13.231,18.423h3.433L55.15,205.071Z",
    transform: "translate(-43.174 -182.963)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M221.1,221.864h2.764V196.909h.084V181.5H221.1Z",
    transform: "translate(-70.698 -181.5)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M247.63,190.5h-3.768L231.3,204.9l13.231,18.423h3.517l-13.315-18.256Z",
    transform: "translate(-72.356 -182.963)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(294.739 181.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M385.577,197.271a2.094,2.094,0,0,1-2.177-2.094,2.136,2.136,0,1,1,4.271,0A2.185,2.185,0,0,1,385.577,197.271Zm10.384,3.852c-1.256,3.35-4.438,4.857-7.286,6.532.837-3.768,2.094-7.537,1.926-11.389-.084-1.172.084-2.429,1.424-2.847a4.053,4.053,0,0,1,3.35.754C397.218,195.6,396.631,199.2,395.961,201.123Z",
    transform: "translate(-350.322 -184.367)",
    fill: "#fafafa",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M396.4,194.131a4.053,4.053,0,0,0-3.35-.754c-1.34.419-1.424,1.675-1.424,2.847.167,3.852-1.089,7.7-1.926,11.389,2.931-1.675,6.03-3.182,7.286-6.532C397.656,199.239,398.242,195.638,396.4,194.131Z",
    transform: "translate(-351.346 -184.41)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M385.577,192.9a2.023,2.023,0,0,0-2.177,2.177,2.045,2.045,0,0,0,2.177,2.094,2.145,2.145,0,0,0,2.177-2.094A2.112,2.112,0,0,0,385.577,192.9Z",
    transform: "translate(-350.322 -184.351)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M355.038,237.871h-5.443A5.953,5.953,0,0,1,343.9,233.6h0a6.056,6.056,0,0,0,5.778,4.271",
    transform: "translate(-343.9 -190.968)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M357.4,227.961l5.276-2.764c.921-.5,1.926-1,2.847-1.507.754-.419,1.675-1.172,2.6-1.089-1.591,2.847-3.266,5.695-4.857,8.542h5.527l4.02-2.261c2.6-1.424,5.36-2.931,7.118-5.36a9.263,9.263,0,0,0,1.591-6.616,27.591,27.591,0,0,0-1.926-6.532L365.941,191.7c-.5.67-.921,1.424-1.34,2.094l-12.059,19.345c-2.847,4.522-5.694,9.128-8.542,13.65a6.031,6.031,0,0,0,5.695,4.271h5.443a14.42,14.42,0,0,1,.586-1.759A2.715,2.715,0,0,1,357.4,227.961Z",
    transform: "translate(-343.916 -184.156)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M378.558,195.344a5.271,5.271,0,0,1,3.433-6.951,8.531,8.531,0,0,1,4.355.335c1.759.419,3.434.837,5.192,1.089a2.767,2.767,0,0,0,1.172,0c.586-.084.67-.084.754-.5a3.237,3.237,0,0,0-.67-1.759,9.352,9.352,0,0,0-2.764-2.68,13.047,13.047,0,0,0-7.872-2.177,13.5,13.5,0,0,0-7.872,2.847,20.677,20.677,0,0,0-4.187,4.773l13.65,18.675-1.256-3.015C381.238,202.378,379.814,198.861,378.558,195.344Z",
    transform: "translate(-348.159 -182.692)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logoFooter.ba5afe9fbbef4d48b49c6d446bd22361.svg";
export { ForwardRef as ReactComponent };